module.exports = __webpack_public_path__ + "static/img/bg_2.99d2282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_2.jpg
// module id = WFWB
// module chunks = 1